import { User } from '@auth0/auth0-react'
import * as coam from '@cimpress-technology/coam-sapidus'
import { locations } from '@cimpress-technology/logistics-configuration-client'
import * as uuid from 'uuid'
import { logError } from '../logger'
import { SequenceDefinition } from '../models'
import * as proxy from './sequences-proxy'

export async function addSequenceToLocationCoamGroup(
  accessToken: string,
  sequenceId: string,
  locationId: string
) {
  await locations.linkResourceToLocationGroup(
    accessToken,
    uuid.v4(),
    locationId,
    sequenceId,
    coam.models.ResourceTypes.LogisticsSequence
  )
}

export async function createSequenceForLocation(
  accessToken: string,
  user: User | undefined,
  sequenceDefinition: SequenceDefinition,
  locationId: string
): Promise<string> {
  const { _metadata, ...apiSequenceDefinition } = sequenceDefinition

  const sequenceId = await proxy.createSequence(
    accessToken,
    user,
    apiSequenceDefinition
  )

  try {
    await addSequenceToLocationCoamGroup(accessToken, sequenceId, locationId)
  } catch (err) {
    try {
      await proxy.deleteSequence(accessToken, user, sequenceId)
    } catch (err2) {
      logError(
        user,
        `Failed to delete sequence id=${sequenceId} after linking to Location failed`,
        err2
      )
    }

    throw err
  }

  return sequenceId
}

export async function removeSequenceFromLocationCoamGroup(
  accessToken: string,
  sequenceId: string,
  locationId: string
) {
  await locations.unlinkResourceFromLocationGroup(
    accessToken,
    uuid.v4(),
    locationId,
    sequenceId,
    coam.models.ResourceTypes.LogisticsSequence
  )
}

export async function deleteSequenceFromLocation(
  accessToken: string,
  user: User | undefined,
  sequenceId: string,
  locationId: string
): Promise<void> {
  await proxy.deleteSequence(accessToken, user, sequenceId)
  await removeSequenceFromLocationCoamGroup(accessToken, sequenceId, locationId)
}

export async function getSequenceDirect(
  accessToken: string,
  user: User | undefined,
  url: string
) {
  return proxy.getSequenceDirect(accessToken, user, url)
}

export async function patchSequence(
  accessToken: string,
  user: User | undefined,
  sequenceId: string,
  diff: any
) {
  return proxy.patchSequence(accessToken, user, sequenceId, diff)
}
